import React, { Suspense } from "react";
import { IWidgetTemplateProps } from "../../../common/common";

// The swiper-rendering leaf is code-split into its own chunk so the ~660 KiB
// swiper dependency stays out of the eager bundle. This module is still the
// eager import target of templates.ts (registration eagerness unchanged), but
// swiper is only fetched when this widget actually renders.
const CardSectionSwiperListView = React.lazy(
  () => import(/* webpackChunkName: "card-section-swiper" */ "./CardSectionSwiperListView")
);

const CardListWidget: React.FunctionComponent<IWidgetTemplateProps> = (props) => (
  <Suspense fallback={null}>
    <CardSectionSwiperListView {...props} />
  </Suspense>
);

export default CardListWidget;

// registerCardTemplate({
//   id: 'card-list',
//   template: CardListWidget,
//   name: 'Card List',
//   description: 'Scrollable Card List',
//   complexity: 'easy',
//   layout: {
//     w: 9,
//     h: 12
//   },
// });

// registerMobileCardTemplate({
//   id: 'card-list',
//   template: CardListWidget,
//   name: 'Card List',
//   description: 'Horizontal list of cards'
// })
